import '../style/yearpage.css';
import { useNavigate } from 'react-router-dom';
import JordanImage from '../components/jordan.png';
import LithuaniaImage from '../components/lithuania.jpeg';
import SloveniaImage from '../components/slovenia-flag.jpg';

function Year2019() {
    const navigate = useNavigate(); // Initialize the navigate function
  
    // Function to handle container clicks
    const handleContainerClick = (path) => {
      navigate(path); // Navigate to the specified path
    };
  
    const handleBackClick = () => {
      navigate('/'); // Navigate to the home page
    };

    return (
      <div className="year-page">
        <h1>2019 Photos</h1>
        <button 
        className="back-button" 
        onClick={handleBackClick}
      >
        ← Back 
      </button>
        <div className="location-grid">
          {/* Jordan Location */}
          <div
            className="location-container"
            onClick={() => handleContainerClick('/jordan')} // Redirect to /jordan
            style={{ cursor: 'pointer' }} // Add pointer cursor to indicate clickability
          >
            <div
              className="image-container"
              style={{ backgroundImage: `url(${JordanImage})` }}
            ></div>
            <p className="location-name">Jordan</p>
          </div>
  
          {/* Lithuania Location */}
          <div
            className="location-container"
            onClick={() => handleContainerClick('/lithuania')} // Redirect to /lithuania
            style={{ cursor: 'pointer' }} // Add pointer cursor to indicate clickability
          >
            <div
              className="image-container"
              style={{ backgroundImage: `url(${LithuaniaImage})` }}
            ></div>
            <p className="location-name">Lithuania</p>
          </div>
  
          {/* Slovenia Location */}
          <div
            className="location-container"
            onClick={() => handleContainerClick('/slovenia')} // Redirect to /slovenia
            style={{ cursor: 'pointer' }} // Add pointer cursor to indicate clickability
          >
            <div
              className="image-container"
              style={{ backgroundImage: `url(${SloveniaImage})` }}
            ></div>
            <p className="location-name">Slovenia</p>
          </div>
        </div>
      </div>
    );
  }
  
  export default Year2019;